import { device } from "../util/media-query";

export type HeadingType = "h1" | "h2" | "h3" | "h4" | "h5";
export type ParagraphType = "p" | "span";
export type ParagraphSize = "large" | "medium" | "small";
export type TextTransformType =
  | "none"
  | "lowercase"
  | "uppercase"
  | "capitalize";
export type TextAlignType = "center" | "left" | "right" | "justify";

export const typeStyle: Record<HeadingType | ParagraphSize, string> = {
  h1: `
		font-size: 4.8rem;
  `,
  h2: `
		font-size: 2.4rem;
		letter-spacing: 0.25em;
		line-height: 1;

    @media ${device.desktopM} {
      font-size: 3.6rem;
		}

		@media ${device.desktopL} {
      font-size: 4.8rem;
      line-height: 1.5;
    }
  `,
  h3: `
		font-size: 2.4rem;
		letter-spacing: 0.25em;
    line-height: 1;
    margin: 0.42em 0;

    html:lang(pt) &,
    html:lang(th) &,
    html:lang(vi) & {
      letter-spacing: 0.2em;
    }

    html:lang(el) &,
    html:lang(es) &,
    html:lang(fr) &,
    html:lang(hu) &,
    html:lang(ro) & {
      letter-spacing: 0.16em;
    }

    html:lang(ja) & {
      letter-spacing: 0.05em;
    }

		@media ${device.desktopM} {
      font-size: 3rem;
		}

		@media ${device.desktopL} {
      font-size: 3.6rem;
    }
  `,
  h4: `
    font-size: 100%;
  `,
  h5: `
    font-size: 100%;
  `,
  large: `
    font-size: 2.0rem;
  `,
  medium: `
    font-size: 1.8rem;
    letter-spacing: 0.09em;
    line-height: 1.25;

    @media ${device.desktopL} {
      font-size: 2.4rem;
    }
  `,
  small: `
    font-size: 1.2rem;
  `,
};
